
export enum RuleDomain {
  Notification = 1,
  Access = 2
}
